export default "__VITE_ASSET__BsYzf3md__"